import type { QueryClient } from "@tanstack/react-query";

import { reportingQueryKeys } from "./query-keys";

import { ModuleToggleHandler, registerModuleToggleHandlerByModule } from "@/features/integrations/hooks/moduleToggleHandlers";

/**
 * Clear reporting cache when any integration's reporting module is toggled (same pattern as job-sync).
 * We remove queries so no refetch runs immediately; the next time the reporting page is opened it will fetch fresh data.
 */
function registerReportingModuleToggleHandlers(): void {
  const clearReportingCache: ModuleToggleHandler = (queryClient: QueryClient) => {
    queryClient.removeQueries({
      queryKey: reportingQueryKeys.all,
    });
  };

  registerModuleToggleHandlerByModule("reporting", clearReportingCache);
}

registerReportingModuleToggleHandlers();
